export default "__VITE_PUBLIC_ASSET__6f40d08f__"